import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-isomasters-text-copy',
  templateUrl: './isomasters-text-copy.component.html',
  styleUrls: ['./isomasters-text-copy.component.scss'],
})
export class IsomastersTextCopyComponent implements OnInit {
  @Input() value: string;
  buttonClicked = false;
  constructor() {}

  ngOnInit(): void {}

  click() {
    this.buttonClicked = true;
    setTimeout(() => (this.buttonClicked = false), 250);
  }
}
